import React,{useState,useEffect} from 'react'
import ContactServices from '../services/ContactServices'
import useAsync from '../hooks/useAsync'
function Contect() {
  const {data , error, isLoading} = useAsync(ContactServices.getContact);
  // console.log(data)

  const [formValues, setFormValues] = useState({
    phone: '',
    email: '',
    whatsApp: '',
    faceBook: '',
    linkedin: '',
    version: '',
    twitter: '',
    instagram: '',
    youtube:'',
  });

  // Update form values when data is fetched
  useEffect(() => {
    if (data.data) {
      setFormValues({
        email: data.data.email || '',
        phone: data.data.phone || '',
        whatsApp: data.data.whatsApp || '',
        faceBook: data.data.faceBook || 'https://',
        linkedin: data.data.linkedin || 'https://',
        instagram: data.data.instagram || 'https://',
        version: data.data.version || 'https://',
        twitter: data.data.twitter || 'https://',
        youtube: data.data.youtube || 'https://'
      });
    }
  }, [data]);

  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      // console.log(formValues)
      await ContactServices.updateContact(formValues); // Assuming updateContactDetail is a method in UserServices
      alert('Contact details updated successfully');
    } catch (error) {
      console.error('Failed to update contact details', error);
      alert('Failed to update contact details');
    }
  };

 

  return (
    <>
    <div className="right_col" role="main">
        <div className="title-box">
          <h2>SUPPORT CONTACT</h2>
        </div>
        <div className="container-box px-4">
          <div className="container-box-inner">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>Customer Care Number*</label>
                      <input 
                        type="text" 
                        name="phone" 
                        className="form-control" 
                        value={formValues.phone} 
                        onChange={handleInputChange} 
                        maxLength={10}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>WhatsApp No.*</label>
                      <input 
                        type="text" 
                        name="whatsApp" 
                        className="form-control" 
                        value={formValues.whatsApp} 
                        onChange={handleInputChange} 
                        maxLength={10}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>Facebook Link*</label>
                      <div className="input-link-outer">
                        <input 
                          type="text" 
                          name="faceBook" 
                          className="form-control" 
                          value={formValues.faceBook} 
                          onChange={handleInputChange} 
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>Twitter Link*</label>
                      <div className="input-link-outer">
                        <input 
                          type="text" 
                          name="twitter" 
                          className="form-control" 
                          value={formValues.twitter} 
                          onChange={handleInputChange} 
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>Instagram Link*</label>
                      <div className="input-link-outer">
                        <input 
                          type="text" 
                          name="instagram" 
                          className="form-control" 
                          value={formValues.instagram} 
                          onChange={handleInputChange}
                          required 
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>Linkedin Link*</label>
                      <div className="input-link-outer">
                        <input 
                          type="text" 
                          name="linkedin" 
                          className="form-control" 
                          value={formValues.linkedin} 
                          onChange={handleInputChange} 
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>YouTube Link*</label>
                      <div className="input-link-outer">
                        <input 
                          type="text" 
                          name="youtube" 
                          className="form-control" 
                          value={formValues.youtube} 
                          onChange={handleInputChange} 
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="input-field">
                      <label>Version*</label>
                      <div className="input-link-outer">
                        <input 
                          type="text" 
                          name="version" 
                          className="form-control" 
                          value={formValues.version} 
                          onChange={handleInputChange} 
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <button type="submit" className="site-btn-green">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Contect